module.exports = __webpack_public_path__ + "static/media/Article 4.a1e585e0.svg";